(function () {
  'use strict';

  var selector = '[data-og-riser-scroll]';
  var disclosureSelector = '[data-og-riser-disclosure]';
  var disclosureDuration = 520;
  var disclosureEasing = 'cubic-bezier(.16, 1, .3, 1)';
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var mobileViewport = window.matchMedia('(max-width: 989px)');

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function resetDisclosureAnimation(disclosure, panel) {
    window.clearTimeout(disclosure._ogRiserDisclosureTimer);
    window.cancelAnimationFrame(disclosure._ogRiserDisclosureFrame);
    disclosure._ogRiserDisclosureTimer = 0;
    disclosure._ogRiserDisclosureFrame = 0;

    if (disclosure._ogRiserDisclosureTransitionEnd) {
      panel.removeEventListener('transitionend', disclosure._ogRiserDisclosureTransitionEnd);
      disclosure._ogRiserDisclosureTransitionEnd = null;
    }

    panel.style.removeProperty('height');
    panel.style.removeProperty('overflow');
    panel.style.removeProperty('transition');
    panel.style.removeProperty('will-change');
  }

  function requestSceneUpdate(disclosure) {
    var scene = disclosure.querySelector(selector);
    if (scene && scene._ogRiserUpdate) scene._ogRiserUpdate();
  }

  function setDisclosureExpanded(disclosure, expanded, animate) {
    var trigger = disclosure.querySelector('[data-og-riser-disclosure-trigger]');
    var panel = disclosure.querySelector('[data-og-riser-disclosure-panel]');
    if (!trigger || !panel || disclosure.dataset.ogRiserDisclosureAnimating === 'true') return;

    resetDisclosureAnimation(disclosure, panel);
    trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    disclosure.classList.toggle('is-opening', expanded);
    disclosure.classList.toggle('is-closing', !expanded);
    disclosure.classList.toggle('is-expanded', expanded);

    function finish() {
      resetDisclosureAnimation(disclosure, panel);
      disclosure.classList.remove('is-opening', 'is-closing');
      delete disclosure.dataset.ogRiserDisclosureAnimating;

      if (expanded) {
        panel.removeAttribute('aria-hidden');
        requestSceneUpdate(disclosure);
      } else {
        disclosure.open = false;
        panel.setAttribute('aria-hidden', 'true');
      }
    }

    if (expanded) {
      disclosure.open = true;
      panel.removeAttribute('aria-hidden');
    }

    if (!animate || reducedMotion.matches) {
      finish();
      return;
    }

    disclosure.dataset.ogRiserDisclosureAnimating = 'true';
    panel.style.overflow = 'hidden';
    panel.style.willChange = 'height';
    panel.style.transition = 'none';
    panel.style.height = (expanded ? 0 : panel.getBoundingClientRect().height) + 'px';
    void panel.offsetHeight;

    disclosure._ogRiserDisclosureTransitionEnd = function (event) {
      if (event.target !== panel || event.propertyName !== 'height') return;
      finish();
    };
    panel.addEventListener('transitionend', disclosure._ogRiserDisclosureTransitionEnd);

    disclosure._ogRiserDisclosureFrame = window.requestAnimationFrame(function () {
      disclosure._ogRiserDisclosureFrame = 0;
      panel.style.transition = 'height ' + disclosureDuration + 'ms ' + disclosureEasing;
      panel.style.height = (expanded ? panel.scrollHeight : 0) + 'px';
    });

    disclosure._ogRiserDisclosureTimer = window.setTimeout(finish, disclosureDuration + 100);
  }

  function initDisclosure(disclosure) {
    if (!disclosure || disclosure.dataset.ogRiserDisclosureReady === 'true') return;

    var trigger = disclosure.querySelector('[data-og-riser-disclosure-trigger]');
    var panel = disclosure.querySelector('[data-og-riser-disclosure-panel]');
    if (!trigger || !panel) return;

    function onToggle(event) {
      event.preventDefault();
      setDisclosureExpanded(disclosure, !disclosure.open, true);
    }

    trigger.setAttribute('aria-expanded', disclosure.open ? 'true' : 'false');
    disclosure.classList.toggle('is-expanded', disclosure.open);
    if (disclosure.open) {
      panel.removeAttribute('aria-hidden');
    } else {
      panel.setAttribute('aria-hidden', 'true');
    }

    trigger.addEventListener('click', onToggle);
    disclosure._ogRiserDisclosureCleanup = function () {
      trigger.removeEventListener('click', onToggle);
      resetDisclosureAnimation(disclosure, panel);
      disclosure.classList.remove('is-opening', 'is-closing');
      delete disclosure.dataset.ogRiserDisclosureAnimating;
      delete disclosure.dataset.ogRiserDisclosureReady;
      delete disclosure._ogRiserDisclosureCleanup;
    };
    disclosure.dataset.ogRiserDisclosureReady = 'true';
  }

  function init(section) {
    if (!section || section.dataset.ogRiserReady === 'true') return;

    var images = Array.prototype.slice.call(section.querySelectorAll('[data-og-riser-image]'));
    var swatches = Array.prototype.slice.call(section.querySelectorAll('[data-og-riser-swatch]'));
    var finish = section.querySelector('[data-og-riser-finish]');
    var product = section.querySelector('[data-og-riser-product]');
    var productLink = section.querySelector('[data-og-riser-product-link]');
    var progressBar = section.querySelector('[data-og-riser-progress]');
    var baseUrl = productLink ? productLink.getAttribute('href').split('?')[0] : '';
    var activeIndex = 0;
    var frame = 0;
    var flashTimer = 0;
    var swipeStart = null;
    var suppressClickUntil = 0;

    if (images.length < 2) return;
    section.dataset.ogRiserReady = 'true';

    function setActive(nextIndex, flash) {
      nextIndex = clamp(nextIndex, 0, images.length - 1);
      if (nextIndex === activeIndex && !flash) return;

      activeIndex = nextIndex;
      images.forEach(function (image, index) {
        image.classList.toggle('is-active', index === activeIndex);
        image.setAttribute('aria-hidden', index === activeIndex ? 'false' : 'true');
      });
      swatches.forEach(function (swatch, index) {
        var selected = index === activeIndex;
        swatch.classList.toggle('is-active', selected);
        swatch.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });

      var activeImage = images[activeIndex];
      if (finish) finish.textContent = activeImage.dataset.finish || '';
      if (productLink && activeImage.dataset.variant) {
        productLink.href = baseUrl + '?variant=' + activeImage.dataset.variant;
        productLink.setAttribute(
          'aria-label',
          'Shop OG 8.5 inch Pull-Back Risers in ' +
            (activeImage.dataset.finish || 'the displayed finish') +
            (mobileViewport.matches ? '. Swipe left or right to preview finishes.' : '')
        );
      }

      if (flash && product && !reducedMotion.matches) {
        window.clearTimeout(flashTimer);
        product.classList.remove('is-flashing');
        void product.offsetWidth;
        product.classList.add('is-flashing');
        flashTimer = window.setTimeout(function () {
          product.classList.remove('is-flashing');
        }, 220);
      }
    }

    function update() {
      frame = 0;
      var disclosure = section.closest(disclosureSelector);
      if (disclosure && !disclosure.open) return;

      var rect = section.getBoundingClientRect();
      var travel = Math.max(section.offsetHeight - window.innerHeight, 1);
      var progress = clamp(-rect.top / travel, 0, 1);
      var nextIndex = Math.round(progress * (images.length - 1));
      var changed = nextIndex !== activeIndex;

      setActive(nextIndex, changed);
      section.style.setProperty('--og-riser-progress', progress.toFixed(4));
      if (progressBar) progressBar.style.transform = 'scaleX(' + progress.toFixed(4) + ')';
    }

    function requestUpdate() {
      if (frame) return;
      frame = window.requestAnimationFrame(update);
    }

    function scrollToIndex(index, behavior) {
      var sectionTop = section.getBoundingClientRect().top + window.scrollY;
      var travel = Math.max(section.offsetHeight - window.innerHeight, 1);
      var destination = sectionTop + (index / (images.length - 1)) * travel;
      window.scrollTo({ top: destination, behavior: behavior });
    }

    function onPointerDown(event) {
      if (!mobileViewport.matches || (event.button !== undefined && event.button !== 0)) return;
      swipeStart = {
        id: event.pointerId,
        x: event.clientX,
        y: event.clientY
      };
      if (productLink.setPointerCapture) productLink.setPointerCapture(event.pointerId);
    }

    function onPointerEnd(event) {
      if (!swipeStart || event.pointerId !== swipeStart.id) return;

      var deltaX = event.clientX - swipeStart.x;
      var deltaY = event.clientY - swipeStart.y;
      var isHorizontalSwipe = Math.abs(deltaX) >= 42 && Math.abs(deltaX) > Math.abs(deltaY) * 1.15;
      swipeStart = null;

      if (!isHorizontalSwipe) return;
      suppressClickUntil = Date.now() + 550;

      var nextIndex = clamp(activeIndex + (deltaX < 0 ? 1 : -1), 0, images.length - 1);
      if (nextIndex === activeIndex) return;
      setActive(nextIndex, true);
      scrollToIndex(nextIndex, 'auto');
    }

    function onPointerCancel() {
      swipeStart = null;
    }

    function onProductClick(event) {
      if (Date.now() < suppressClickUntil) {
        event.preventDefault();
        event.stopPropagation();
      }
    }

    function onDragStart(event) {
      event.preventDefault();
    }

    swatches.forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        var index = Number(swatch.dataset.index || 0);
        setActive(index, true);
        scrollToIndex(index, reducedMotion.matches ? 'auto' : 'smooth');
      });
    });

    if (productLink) {
      productLink.addEventListener('pointerdown', onPointerDown);
      productLink.addEventListener('pointerup', onPointerEnd);
      productLink.addEventListener('pointercancel', onPointerCancel);
      productLink.addEventListener('click', onProductClick, true);
      productLink.addEventListener('dragstart', onDragStart);
    }

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    section._ogRiserCleanup = function () {
      window.removeEventListener('scroll', requestUpdate);
      window.removeEventListener('resize', requestUpdate);
      window.cancelAnimationFrame(frame);
      window.clearTimeout(flashTimer);
      if (productLink) {
        productLink.removeEventListener('pointerdown', onPointerDown);
        productLink.removeEventListener('pointerup', onPointerEnd);
        productLink.removeEventListener('pointercancel', onPointerCancel);
        productLink.removeEventListener('click', onProductClick, true);
        productLink.removeEventListener('dragstart', onDragStart);
      }
      delete section._ogRiserUpdate;
      delete section.dataset.ogRiserReady;
    };
    section._ogRiserUpdate = requestUpdate;

    setActive(0, false);
    update();
  }

  function initAll(scope) {
    var root = scope || document;
    Array.prototype.forEach.call(root.querySelectorAll(disclosureSelector), initDisclosure);
    Array.prototype.forEach.call(root.querySelectorAll(selector), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    Array.prototype.forEach.call(event.target.querySelectorAll(disclosureSelector), function (disclosure) {
      if (disclosure._ogRiserDisclosureCleanup) disclosure._ogRiserDisclosureCleanup();
    });
    Array.prototype.forEach.call(event.target.querySelectorAll(selector), function (section) {
      if (section._ogRiserCleanup) section._ogRiserCleanup();
    });
  });
})();
